<div class="dialog" fxLayout="column">

  <div mat-dialog-header fxLayout="column" fxLayoutGap="10px">
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div class="title-letter" fxLayout="row" fxLayoutGap="10px">
        <mat-icon>edit</mat-icon>
        <span>{{'詳細' | translate}}</span>
      </div>

      <div class="top-buttons" fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="addDescs()" [disabled]="!descsFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span>{{'更新' | translate}}</span>
        </button>
        
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content fxFlex="600px" style="overflow: auto;">
    <form *ngIf="!!descsFormGroup" [formGroup]="descsFormGroup">
      <div fxLayout="row" fxLayoutGap="20px">
        <!-- <mat-checkbox formControlName="autoTrans" color="primary">{{'全言語自動翻訳' | translate}}</mat-checkbox> -->
        <mat-checkbox (change)="onChangeAutoAllTrans()" formControlName="autoAllTrans" color="primary">{{'全言語自動翻訳' | translate}}</mat-checkbox>
        <mat-checkbox (change)="onChangeAutoAllVoice()" formControlName="autoAllVoice" color="primary">{{'全言語音声作成' | translate}}</mat-checkbox>
      </div>
      <div *ngIf="!!descsArrayControl" formArrayName="descs">
        <mat-tab-group mat-align-tabs="start">
          <!-- <mat-tab *ngFor="let descForm of descsArrayControl.controls; let i=index" [formGroupName]="i"
            [label]="currentLang === 'ja' ? projectLanguages[i].lang_name : projectLanguages[i].display_name"> -->
          <mat-tab *ngFor="let descForm of descsArrayControl.controls; let i=index" [formGroupName]="i"
            [label]="currentLang == 'en' ? (projectLanguages[i].lang_name_en ? projectLanguages[i].lang_name_en : (projectLanguages[i].lang_name | translate)):  projectLanguages[i].lang_name">
            <div fxLayout="column" fxLayoutGap="10px">
              <div fxLayout="row" fxLayoutGap="20px">
                <mat-checkbox *ngIf="i !== 0" (change)="onChangeAutoTrans()" formControlName="autoTrans"
                  color="primary">{{'自動翻訳' | translate}}</mat-checkbox>
                <mat-checkbox (change)="onChangeAutoVoice()" formControlName="autoVoice" color="primary">{{'音声作成' |
                  translate}}</mat-checkbox>
              </div>
              <div fxLayout="row" fxLayoutGap="10px">
                <mat-form-field fxFlex="100%">
                  <mat-label floatLabel="always">{{'詳細' | translate}}</mat-label>
                  <textarea matInput placeholder="{{'詳細' | translate}}" formControlName="desc" rows="20"></textarea>
                </mat-form-field>
                <mat-form-field *ngIf="i === 0" fxFlex="100%">
                  <mat-label floatLabel="always">{{'翻訳用詳細' | translate}}</mat-label>
                  <textarea matInput placeholder="{{'翻訳用詳細' | translate}}" formControlName="transDesc" rows="20"></textarea>
                </mat-form-field>
                <mat-form-field fxFlex="100%">
                  <mat-label floatLabel="always">{{'音声用詳細' | translate}}</mat-label>
                  <textarea matInput placeholder="{{'音声用詳細' | translate}}" formControlName="voiceDesc" rows="20"></textarea>
                </mat-form-field>
              </div>
              <div fxLayout="column" fxFlex="100%">
                <div fxLayout="row" fxLayoutGap="10px">
                  <mat-form-field fxFlex="50%">
                    <mat-label floatLabel="always">{{'音声ファイル' | translate}}</mat-label>
                    <input matInput placeholder="{{'音声ファイル' | translate}}" formControlName="voiceFileName" readonly>
                  </mat-form-field>
                  <button mat-stroked-button color="warn" [hidden]="!descForm.get('voiceFileName')!.value"
                    (click)="deleteVoiceFile(i)">
                    <mat-icon>clear</mat-icon>
                  </button>
                  <button mat-stroked-button [disabled]="descForm.get('autoVoice')!.value"
                    (click)="openSelectVoiceFileDialog(i)">
                    <mat-icon>add</mat-icon>
                    <span>{{'ファイル選択' | translate}}</span>
                  </button>
                </div>
                <audio *ngIf="!!descForm.get('voiceDownloadUrl')!.value" [src]="descForm.get('voiceDownloadUrl')!.value"
                  controls></audio>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </form>
  </div>


</div>